import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { Checkbox, Select, Divider } from 'antd'

import { Flex, FlexColumn } from '../../Reusable/Container'
import { LabeledInput } from '../../Reusable/Input'
import { Text } from '../../Reusable/Text'
import { Image } from '../../Reusable/Image'
import { Button, TextButton } from '../../Reusable/Button'
import { ErrorAlert } from '../../Reusable/Alert'
import Banner from '../../Reusable/Banner'
import { apiPOSTReq } from '../../../Utils/api'
import environment from '../../../environment'

import SearchBanks from './SearchBanks'
import SearchRTPBanks from './SearchRTPBanks'
import { getFeaturePerm, countryNameToCodeMap, generatePlaceholderFromRegex, splitByFirstSpace, getStreetFromAddressObjectToStr, countryCodeToNameMap, generateUniqueNickname, generateSimplePlaceholder } from '../../../Utils/util'
import AionIcon from '../../../Images/aion-shadow.png'
import BofAIcon from '../../../Images/bofa-icon.png'
import ChaseIcon from '../../../Images/chase-icon.png'
import Search from '../../../Images/icon-search.svg'
import { LoadingOutlined } from '@ant-design/icons';

const { Option } = Select

class AddTransferModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            transfer: {
                type: props.transferMethod ? props.transferMethod.type : null,
                name: props.transferMethod ? props.transferMethod.nickName : null,
                accountNumber: props.transferMethod ? props.transferMethod.bankDetail.accountNumber : null,
                routingNumber: props.transferMethod ? props.transferMethod.bankDetail.routingNumber : null,
                addressOnAccount: props.transferMethod ? props.transferMethod.bankDetail.addressOnAccount : null,
                accountType: props.transferMethod ? props.transferMethod.bankDetail.accountType : (props.rail && props.rail === 'Instant') ? 'Checking' : null,
                remittanceInfo: props.transferMethod ? props.transferMethod.remittanceInfo : null,

                iban: props.transferMethod?.bankDetail?.internationalPaymentDetails?.iban,
                bicSwift: props.transferMethod?.bankDetail?.internationalPaymentDetails?.bicSwift,
                routingCodeValue1: props.transferMethod?.bankDetail?.internationalPaymentDetails?.routingCodeValue1,
                routingCodeValue2: props.transferMethod?.bankDetail?.internationalPaymentDetails?.routingCodeValue2,
                receiverAccountNumber: props.transferMethod?.bankDetail?.internationalPaymentDetails?.receiverAccountNumber,
                bankName: props.transferMethod?.bankDetail?.internationalPaymentDetails?.bankName,
                addressOnAccountInt: props.transferMethod ? props.transferMethod.bankDetail.addressOnAccount : null,
            },
            nameError: false,
            accountNumberError: false,
            routingNumberError: false,
            addressOnAccountError: false,
            banks: [
                {
                    key: 'aion',
                    name: 'Aion',
                    icon: AionIcon,
                },
                {
                    key: 'bofa',
                    name: 'Bank of America',
                    icon: BofAIcon,
                },
                {
                    key: 'chase',
                    name: 'Chase',
                    icon: ChaseIcon,
                },
            ],
            type: props.rail ? props.rail : props.transferMethod ? props.transferMethod.type : null,
            aionAccount: (props.transferMethod && props.transferMethod.bankDetail.bankName === "Aion Banking (Powered by Cross River Bank)") ? true : false,
            accountId: props.transferMethod ? props.transferMethod.accountId : null,
            step: "currency",
            country: props.transferMethod?.bankDetail?.internationalPaymentDetails?.countryCode ? countryCodeToNameMap[props.transferMethod.bankDetail?.internationalPaymentDetails?.countryCode] : null,
            currency: props.transferMethod?.bankDetail?.internationalPaymentDetails?.currency ? props.transferMethod.bankDetail?.internationalPaymentDetails?.currency?.toUpperCase() : null,
            priority: props.transferMethod ? (props.transferMethod?.bankDetail?.internationalPaymentDetails?.priority ? "SWIFT" : "Local Bank Account") : null,
            countryCode: props.transferMethod?.bankDetail?.internationalPaymentDetails?.countryCode,
        }

        this.nameRef = React.createRef()
        this.accountNumberRef = React.createRef()
        this.routingNumberRef = React.createRef()
        this.addressOnAccountRef = React.createRef()
    }

    handleTextChange = (event) => {
        const { transfer } = this.state
        transfer[event.target.id] = event.target.value
        if (event.target.id === "routingNumber") {
            transfer.name = null
            this.setState({ bankLogo: null, instantInstitution: null, institution: null })
        }
        this.setState({ transfer })
    }

    handleFocusChange = (event) => {
        const { transfer, type } = this.state
        var { routingNumber } = transfer

        if (routingNumber && routingNumber.length < 9) {
            this.setState({ routingNumberError: true })
        }

        if (routingNumber && routingNumber.length === 9) {
            this.setState({ routingNumberError: false })
            const target = event.target
            if (type === "Instant") {
                this.fetchInstantSearchResults(target.value)
            } else {
                this.getInstitutionDetails(true)
            }
        }
    }

    // handleBankSelect = (value, option) => {
    //     const { transfer, banks } = this.state

    //     const bank = banks.find(bank => bank.key === value)
    //     transfer.bankName = bank.name
    //     transfer.bankIcon = bank.icon

    //     console.log('handleBankSelect', transfer)

    //     this.setState({ transfer })
    // }

    setType = (type) => {
        const { transferMethodRequests } = this.props
        const { transfer, country, currency, priority } = this.state
        transfer.type = type
        // transfer.routingNumber = type === 'Instant' ? "021214891" : null
        transfer.accountType = type === 'Instant' ? 'Checking' : null
        if (type === 'International') transfer.name = generateUniqueNickname(transferMethodRequests, transfer?.bankName, type, country, currency, priority);
        else transfer.name = generateUniqueNickname(transferMethodRequests, transfer?.bankName, type)
        this.setState({ transfer, type, searchInstantRoutingNumber: false })
    }

    setAccountType = (type) => {
        const { transfer } = this.state
        transfer.accountType = type
        this.setState({ transfer })
    }

    setCDType = (checkDeliveryType) => {
        const { transfer } = this.state
        transfer.checkDeliveryType = checkDeliveryType
        this.setState({ transfer, checkDeliveryType })
    }

    getLocation = (address, key) => {
        const { transfer } = this.state
        transfer[key] = address
        this.setState({ transfer })
    }

    handleBankSelect = (bank) => {
        console.log('generateUniqueNickname bank', bank)
        const { transferMethodRequests } = this.props
        var { transfer, type } = this.state;
        const bankName = (bank.customerName || bank.institutionName || bank.name)?.trim()
        transfer.bankName = bankName;
        transfer.routingNumber = bank.routingNumber;
        transfer.name = generateUniqueNickname(transferMethodRequests, bankName, type)
        this.setState({ selectedBank: bank, transfer: transfer })
    }

    validate = () => {
        var { transfer, type, internationalQuoteRequirements } = this.state
        var { transferMethodRequests, editing } = this.props
        var { name, accountNumber, routingNumber, addressOnAccount, accountType, checkDeliveryType, iban,
            bicSwift, routingCodeValue1, routingCodeValue2, receiverAccountNumber, addressOnAccountInt, bankName } = transfer

        this.setState({ errorField: null })

        console.log('AddTransferModal validate', transfer)

        if (!name) {
            this.nameRef.current.focus()
            this.setState({ errorField: 'name', nameErrorText: "Nickname is required" })
            return
        }

        if (!editing && transferMethodRequests && transferMethodRequests.find(request => request.nickName === name)) {
            this.nameRef.current.focus()
            this.setState({ errorField: 'name', nameErrorText: "Nickname must be unique" })
            return
        }

        if (!type) {
            this.setState({ errorField: 'type' })
            return
        }

        if (type === 'Check' && !checkDeliveryType) {
            this.setState({ errorField: 'checkDeliveryType' })
            return
        }

        if ((type !== 'Check' && type !== 'International') && (!routingNumber || isNaN(routingNumber) || routingNumber.length != 9)) {
            this.routingNumberRef.current.focus()
            this.setState({ errorField: 'routingNumber' })
            return
        }

        if ((type !== 'Check' && type !== 'International') && (!accountNumber || isNaN(accountNumber))) {
            this.accountNumberRef.current.focus()
            this.setState({ errorField: 'accountNumber' })
            return
        }

        if ((type === 'Wire' || type === 'Check') && (!addressOnAccount || !addressOnAccount.line1 || addressOnAccount.line1 === '' || !addressOnAccount.city ||
            addressOnAccount.city === '' || !addressOnAccount.state || addressOnAccount.state === '' || !addressOnAccount.postalCode || addressOnAccount.postalCode === '')) {
            if (!(type === 'Check' && checkDeliveryType === 'Email')) {
                this.setState({ errorField: 'addressOnAccount' })
                return
            }
        }

        if ((type !== 'Check' && type !== 'International') && !accountType) {
            this.setState({ errorField: 'accountType' })
            return
        }

        if (type === 'International' && internationalQuoteRequirements?.bicSwift) {
            const isBicSwiftInvalid = !bicSwift || !new RegExp(internationalQuoteRequirements.bicSwift).test(bicSwift);

            if (isBicSwiftInvalid) {
                this.setState({ errorField: 'bicSwift' });
                return;
            }
        }

        if (type === 'International' && internationalQuoteRequirements?.iban) {
            const isBicSwiftInvalid = !iban || !new RegExp(internationalQuoteRequirements.iban).test(iban);

            if (isBicSwiftInvalid) {
                this.setState({ errorField: 'iban' });
                return;
            }
        }

        if (type === 'International' && internationalQuoteRequirements?.routingCodeValue1) {
            const isRoutingCodeValue1Invalid = !routingCodeValue1 || !new RegExp(internationalQuoteRequirements.routingCodeValue1).test(routingCodeValue1);

            if (isRoutingCodeValue1Invalid) {
                this.setState({ errorField: 'routingCodeValue1' });
                return;
            }
        }

        if (type === 'International' && internationalQuoteRequirements?.routingCodeValue2) {
            const isRoutingCodeValue2Invalid = !routingCodeValue2 || !new RegExp(internationalQuoteRequirements.routingCodeValue2).test(routingCodeValue2);

            if (isRoutingCodeValue2Invalid) {
                this.setState({ errorField: 'routingCodeValue2' });
                return;
            }
        }

        if (type === 'International' && internationalQuoteRequirements?.receiverAccountNumber) {
            const isReceiverAccountNumberInvalid = !receiverAccountNumber || !new RegExp(internationalQuoteRequirements.receiverAccountNumber).test(receiverAccountNumber);

            if (isReceiverAccountNumberInvalid) {
                this.setState({ errorField: 'receiverAccountNumber' });
                return;
            }
        }

        if (type === 'International' && internationalQuoteRequirements?.bankName) {
            const isBankNameInvalid = !bankName || !new RegExp(internationalQuoteRequirements.bankName).test(bankName);

            if (isBankNameInvalid) {
                this.setState({ errorField: 'bankName' });
                return;
            }
        }

        if (type === 'International') {
            const { address, city, stateProvince, postalCode } = internationalQuoteRequirements || {};

            const missingField = !addressOnAccountInt
                ? 'street'
                : address && (!addressOnAccountInt.line1 || addressOnAccountInt.line1 === '')
                    ? 'street'
                    : city && (!addressOnAccountInt.city || addressOnAccountInt.city === '')
                        ? 'city'
                        : stateProvince && (!addressOnAccountInt.state || addressOnAccountInt.state === '')
                            ? 'state'
                            : postalCode && (!addressOnAccountInt.postalCode || addressOnAccountInt.postalCode === '')
                                ? 'postal code'
                                : null;

            if (missingField) {
                this.setState({
                    errorField: 'addressOnAccountInt',
                    errorMessage: `Please enter a valid ${missingField}`
                });
                return;
            }

            // Map each human-friendly field to the actual field name used in internationalQuoteRequirements
            const fieldMap = {
                street: { fieldName: 'address', value: addressOnAccountInt?.line1, regex: address },
                city: { fieldName: 'city', value: addressOnAccountInt?.city, regex: city },
                state: { fieldName: 'stateProvince', value: addressOnAccountInt?.state, regex: stateProvince },
                'postal code': { fieldName: 'postalCode', value: addressOnAccountInt?.postalCode, regex: postalCode }
            };

            // Identify invalid field
            const invalidKey = Object.keys(fieldMap).find((key) => {
                const { value, regex } = fieldMap[key];
                return regex && !new RegExp(regex).test(value);
            });

            if (invalidKey) {
                const { fieldName, regex } = fieldMap[invalidKey];
                this.setState({
                    errorField: 'addressOnAccountInt',
                    errorMessage: `Please enter a valid ${generateSimplePlaceholder(invalidKey, regex)}`
                });
                return;
            }
        }


        this.setState({ errorField: null })
        this.addTransfer()
    }

    next = () => {
        var { transferMethodRequests, editing } = this.props
        var { transfer, type, nameErrorText, nameError, step, country, currency, priority } = this.state
        var { name, accountNumber, routingNumber, addressOnAccount, accountType, checkDeliveryType } = transfer

        this.setState({ errorField: null })

        if (type !== 'International') {
            this.validate()
            return
        }

        switch (step) {
            case "currency":
                if (!name) {
                    this.nameRef.current.focus()
                    this.setState({ errorField: "name", nameErrorText: "Nickname is required" })
                    return
                }

                if (!editing && transferMethodRequests && !this.props.transferMethod && transferMethodRequests.find(request => request.nickName === name)) {
                    this.nameRef.current.focus()
                    this.setState({ errorField: 'name', nameErrorText: "Nickname must be unique" })
                    return
                }

                if (!type) {
                    this.setState({ errorField: 'type' })
                    return
                }

                if (!country) {
                    this.setState({ errorField: 'country' })
                    return
                }

                if (!currency) {
                    this.setState({ errorField: 'currency' })
                    return
                }

                if (currency?.toLowerCase() !== "usd" && !priority) {
                    this.setState({ errorField: 'priority' })
                    return
                }

                this.setState({ nextLoading: true })
                this.getInternationalQuoteRequirements()
                break
            default:
                this.validate()
                break
        }
    }

    addTransfer = async () => {
        const { recipientId, transferMethod, addTransfer, recipientType, recipientName } = this.props
        const { type, transfer, accountId, internationalQuoteRequirements, currency, country, priority } = this.state
        var { name, accountNumber, routingNumber, addressOnAccount, accountType, bankAddress, checkDeliveryType, remittanceInfo,
            addressOnAccountInt, receiverAccountNumber, bicSwift, routingCodeValue1, routingCodeValue2, bankName, iban } = transfer

        var body = {
            recipientId: recipientId,
            accountId: accountId || accountNumber || "",
            recipientDeliveryMode: type,
            nickName: name,
            type: type,
            bankDetail: {
                bankName: transfer.bankName,
                // accountName: accountNumber,
                accountNumber: accountNumber,
                routingNumber: routingNumber,
                accountType: accountType,
                type: type,
                // bankAddress: bankAddress,
                addressOnAccount: addressOnAccount || addressOnAccountInt,
            },
            remittanceInfo: remittanceInfo,
        }

        if (type == "Check") body.bankDetail.checkDeliveryType = checkDeliveryType

        const logo = await this.getInstitutionDetails()

        if (type == "Instant") {
            const rtpInstResp = await this.getRTPInstitution()

            if (!rtpInstResp.rtpSupportedInstitution) {
                this.setState({ loading: false })
                this.setState({ routingNumberError: true })
                ErrorAlert({ description: rtpInstResp.errorMsg || "This institution does not support instant transfers" })
                return
            }
        }

        body.bankDetail.logoUrl = logo

        if (type === "International") {
            if (receiverAccountNumber) body.bankDetail.accountNumber = receiverAccountNumber
            body.bankDetail.addressOnAccount = addressOnAccountInt

            body.bankDetail.internationalPaymentDetails = {
                currency: currency,
                address: getStreetFromAddressObjectToStr(addressOnAccountInt),
                city: addressOnAccountInt?.city,
                stateProvince: addressOnAccountInt?.countrySubDivisionCode || addressOnAccountInt?.state,
                postalCode: addressOnAccountInt?.postalCode,
                countryCode: countryNameToCodeMap[country],
                routingCodeType1: internationalQuoteRequirements?.routingCodeType1,
                routingCodeValue1: routingCodeValue1,
                routingCodeType2: internationalQuoteRequirements?.routingCodeType2,
                routingCodeValue2: routingCodeValue2,
                bicSwift: internationalQuoteRequirements?.bicSwift && bicSwift,
                iban: internationalQuoteRequirements?.iban && iban,
                bankName: bankName,
                bankCountryCode: countryNameToCodeMap[country],
                // bankAddress: "123, fr",
                receiverAccountNumber: internationalQuoteRequirements?.receiverAccountNumber && receiverAccountNumber,
                entityType: recipientType === "Business" ? "company" : "individual",
                paymentNetwork: (currency?.toLowerCase() === "usd" || priority === "SWIFT") ? "Priority" : "Regular",
                priority: currency?.toLowerCase() === "usd" ? true : priority === "SWIFT",
            }

            if (recipientType === "Business") body.bankDetail.internationalPaymentDetails.companyName = recipientName
            if (recipientType === "Individual") {
                body.bankDetail.internationalPaymentDetails.firstName = splitByFirstSpace(recipientName)[0]
                body.bankDetail.internationalPaymentDetails.lastName = splitByFirstSpace(recipientName)[1]
            }
        }

        if (addTransfer) {
            if (transferMethod) body.paymentMethodId = transferMethod.id

            console.log("AddTransferModal bb/addTransferDelivery body", body)
            this.setState({ loading: true })
            apiPOSTReq(`${environment.bbBaseUrl}/bb/addTransferDelivery`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
                this.setState({ loading: false })
                try {
                    // if (err) throw Error(err)
                    const data = resp || {}
                    if (data.result) {
                        console.log("bb/addTransferDelivery", data)
                        this.props.onConfirm()
                    } else {
                        throw Error(data.responseMessage || data.error)
                    }
                } catch (error) {
                    console.log("/addTransferDelivery err", error, resp, body)
                    ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
                }
            })
        } else {
            this.props.onConfirm(body, transferMethod)
        }
    }

    getInstitutionDetails = async (generateNickname) => {
        const { transferMethodRequests } = this.props
        const { transfer, type } = this.state
        var { routingNumber } = transfer

        return new Promise((resolve) => {
            const body = { routingNumber };
            // this.setState({ loading: true })
            apiPOSTReq(`${environment.integrationBaseUrl}/integration/plaid/getInstitutionDetails`, {}, body, (err, resp) => {
                try {
                    const data = resp;
                    if (data.result && data.institution) {
                        console.log("getInstitutionDetails resp", resp);
                        this.setState({ bankLogo: data.institution.logo, institution: data.institution })
                        if (data.institution?.name) {
                            if (generateNickname) {
                                transfer.bankName = data.institution?.name
                                transfer.name = generateUniqueNickname(transferMethodRequests, data.institution?.name, type)
                            };
                            this.setState({ bankLogo: data.institution.logo, institution: data.institution, transfer })
                        }
                        resolve(data.institution.logo);
                    } else {
                        throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                    }
                } catch (error) {
                    console.log("ERRR getInstitutionDetails", error.stack, resp);
                    // ErrorAlert({ description: error.message });
                    resolve(null); // resolve with null in case of error
                } finally {
                    this.setState({ searchRTPLoading: false })
                }
            });
        });
    }

    getRTPInstitution = async () => {
        const { transfer } = this.state
        var { routingNumber } = transfer
        var body = {
            routingNumber: routingNumber
        }
        return new Promise((resolve) => {
            this.setState({ loading: true, })
            apiPOSTReq(`${environment.bpBaseUrl}/bp/payments/getRTPDirectory`, {}, body, (err, resp) => {
                try {
                    console.log("/bp/payments/getRTPDirectory", err, resp)
                    const data = resp || {}
                    if (data.results) {
                        resolve({ rtpSupportedInstitution: (data.results.length > 0), rtpInstitution: data.results[0] })
                    } else {
                        throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                    }
                } catch (error) {
                    console.log("ERRR getRTPDirectory", error, err, resp)
                    ErrorAlert({ description: error.message })
                    resolve({ errorMsg: error.message })
                }
            })
        })
    }

    fetchInstantSearchResults = (searchText) => {
        const { transferMethodRequests } = this.props
        const { transfer, type } = this.state
        this.setState({ searchRTPLoading: true });
        apiPOSTReq(`${environment.bpBaseUrl}/bp/payments/getRTPDirectory`, {}, { routingNumber: searchText, size: 200 }, (err, resp) => {
            try {
                console.log("AddTransferModal /payments/getRTPDirectory body", { routingNumber: searchText, size: 200 });
                const data = resp || {};
                console.log("AddTransferModal /payments/getRTPDirectory", data);

                if (!data?.results || data?.results.length === 0) this.setState({ routingNumberError: true, searchRTPLoading: false })
                else {
                    this.getInstitutionDetails(true)
                    // if (data?.results[0]?.name) {
                    //     transfer.name = generateUniqueNickname(transferMethodRequests, data?.results[0]?.name, type);
                    // }
                    this.setState({ routingNumberError: false, instantInstitution: data?.results[0], transfer })
                }
            } catch (error) {
                console.log("AddTransferModal /payments/getRTPDirectory", error, err, resp);
                this.setState({ searchRTPLoading: false })
            } finally {
                console.log('AddTransferModal getRTPDirectory finally')
            }
        })
    };

    getInternationalQuoteRequirements = () => {
        const { currency, country, priority, countryCode } = this.state

        const body = {
            InternationalQuoteRequirementsRequestEntity: {
                currency: currency.toLowerCase(),
                beneficiaryCountry: countryCode.toLowerCase(),
                bankCountry: countryCode.toLowerCase(),
                entityType: "Individual",
                priority: currency.toLowerCase() === "usd" ? true : (priority === 'SWIFT'),
            }
        }

        console.log("AddTransferModal getInternationalQuoteRequirements", body);

        apiPOSTReq(`${environment.bpBaseUrl}/bp/payments/getInternationalQuoteRequirements`, { BankProvider: environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp || {};
                console.log("AddTransferModal getInternationalQuoteRequirements data", data);

                if (data?.result === true) this.setState({ internationalQuoteRequirements: data?.bbInternationalQuoteRequirements, step: "transfer" })
                else throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
            } catch (error) {
                console.log("AddTransferModal getInternationalQuoteRequirements", error, err, resp);
                ErrorAlert({ description: error.message })
            } finally {
                this.setState({ nextLoading: false })
            }
        })
    }

    getButtonText = () => {
        const { type, step } = this.state

        if (type !== 'International') return "Confirm"

        switch (step) {
            case "currency":
                return "Next";
            default:
                return "Confirm"
        }
    }

    handleSelectCountry = (country) => {
        const { transferMethodRequests } = this.props
        const { transfer, type } = this.state
        transfer.name = generateUniqueNickname(transferMethodRequests, transfer?.bankName, type, country, null, null)
        this.setState({ country, countryCode: countryNameToCodeMap[country], currency: null, transfer, priority: null })
    }

    isDisabled = () => {
        var { type, currency, country } = this.state

        return !type || (type === "International" && (!country || !currency))
    }

    render() {
        var { loading, dropdownVisible, transfer, banks, type, aionAccount, searchInstantRoutingNumber, searchRTPLoading, bankLogo, nameErrorText,
            instantInstitution, currency, errorField, country, priority, nextLoading, step, internationalQuoteRequirements, errorField, errorMessage, institution } = this.state
        var { name, accountNumber, routingNumber, addressOnAccount, bank, bankAddress, accountType, checkDeliveryType, remittanceInfo, addressOnAccountInt,
            bicSwift, routingCodeValue1, routingCodeValue2, receiverAccountNumber, bankName, iban } = transfer
        const { visible, onDiscard, recipientEmail, transferMethod, rail, addTransfer, theme, currencyMap, transferMethodRequests } = this.props

        var checkPaymentsEnabled = getFeaturePerm("BusinessBanking.Payments.CheckPayment")
        var instantPaymentsEnabled = getFeaturePerm("BusinessBanking.Payments.Instant Transfer")
        const internationalPaymentsEnabled = getFeaturePerm("BusinessBanking.Payments.International Transfer")

        var rails = ['ACH', 'Wire']
        if (checkPaymentsEnabled.manage) rails.push('Check')
        if (instantPaymentsEnabled.manage) rails.unshift('Instant')
        if (internationalPaymentsEnabled.manage) rails.push('International')

        var rInfoLength = 160
        if (type == "ACH") rInfoLength = 80

        var countryItems = []
        Object.keys(currencyMap || {}).forEach(item => {
            countryItems.push(
                <Option key={item} value={item}>
                    {item}
                </Option>
            )
        })

        const disabled = this.isDisabled()

        return (
            <FlexColumn start>
                <FlexColumn start gap='24px'>
                    <Text size='24px' weight={500} color='#444444'>{transferMethod ? 'Edit' : 'New'} Transfer Method</Text>

                    {
                        transferMethod && // (type !== "International" || step === "currency") &&
                        <>
                            <Flex start gap='24px'>
                                <LabeledInput
                                    key="name"
                                    inputRef={this.nameRef}
                                    label='Nickname'
                                    id="name"
                                    // type={(addTransfer && transferMethod) && 'read-only'}
                                    placeholder="Enter nickname for this transfer method"
                                    value={name && name}
                                    autoFocus
                                    nomargin
                                    maxLength={50}
                                    onChange={this.handleTextChange}
                                    error={errorField === 'name'}
                                    errorMessage={nameErrorText}
                                    width={transferMethod ? '270px' : '568px'}
                                />

                                {
                                    transferMethod &&
                                    <LabeledInput
                                        label='Type'
                                        type='read-only'
                                        value={type}
                                        nomargin
                                    />
                                }
                            </Flex>
                        </>
                    }

                    {
                        !transferMethod && !rail &&
                        <LabeledInput
                            label='Type'
                            type='switch'
                            switchNames={rails}
                            onChange={(value) => this.setType(value)}
                            value={type}
                            error={errorField === 'type'}
                            errorMessage='Type is required'
                            nomargin
                        />
                    }

                    {
                        type === "Check" &&
                        <LabeledInput
                            label='Check delivery type'
                            type='switch'
                            switchNames={["Email", "Postal Mail"]}
                            onChange={(value) => this.setCDType(value)}
                            value={checkDeliveryType}
                            error={errorField === 'checkDeliveryType'}
                            errorMessage='Check delivery type is required'
                            nomargin
                        />
                    }

                    {
                        (type && type !== 'International') &&
                        <>
                            {
                                (type != "Check") &&
                                <Checkbox style={{ marginTop: 8, width: 300 }} checked={aionAccount} onChange={(e) => {
                                    transfer.routingNumber = e.target.checked ? "021214891" : null
                                    transfer.bankName = e.target.checked ? "Aion Banking (Powered by Cross River Bank)" : null
                                    transfer.accountType = e.target.checked ? 'Checking' : null
                                    transfer.name = e.target.checked ? generateUniqueNickname(transferMethodRequests, 'Aion', type) : null
                                    this.setState({ aionAccount: e.target.checked, transfer, bankLogo: null, instantInstitution: null })
                                }}>Recipient has their account at Aion</Checkbox>
                            }

                            {type === "Wire" && !aionAccount && (
                                <SearchBanks
                                    handleSelect={bank => this.handleBankSelect(bank)}
                                    width='568px'
                                    nomargin
                                />
                            )}

                            {type === "Instant" && searchInstantRoutingNumber === true && !aionAccount && (
                                <FlexColumn start style={{ margin: "0 0 0" }}>
                                    <SearchRTPBanks
                                        handleSelect={bank => this.handleBankSelect(bank)}
                                        width='568px'
                                        onClear={() => {
                                            transfer.routingNumber = null
                                            this.setState({ transfer })
                                        }}
                                        nomargin
                                    />
                                    {
                                        (type === 'Instant' && searchInstantRoutingNumber) &&
                                        <TextButton
                                            text='Enter routing number manually'
                                            weight='400'
                                            onClick={() => {
                                                transfer.routingNumber = null
                                                this.setState({ searchInstantRoutingNumber: false, routingNumberError: false, transfer })
                                            }}
                                        />
                                    }
                                </FlexColumn>
                            )}

                            {
                                (aionAccount) ?
                                    <FlexColumn start>
                                        <LabeledInput
                                            type='read-only'
                                            label="Routing Number"
                                            value={routingNumber && routingNumber}
                                            width='282px'
                                            nomargin
                                        />

                                        <Flex start fullWidth centerHorizontally gap='8px' style={{ marginTop: 8 }}>
                                            <Image src={AionIcon} />
                                            <Text size='12px'>Aion</Text>
                                        </Flex>
                                    </FlexColumn>
                                    :
                                    <FlexColumn start left style={{ margin: "0 0" }} fullWidth>
                                        {
                                            (type != "Check" && !searchInstantRoutingNumber) &&
                                            <LabeledInput
                                                inputRef={this.routingNumberRef}
                                                label="Routing Number"
                                                id="routingNumber"
                                                key="routingNumber"
                                                placeholder="Enter a 9 digit routing number. Double check with your recipient."
                                                value={routingNumber && routingNumber}
                                                maxLength={9}
                                                onChange={this.handleTextChange}
                                                // onFocus={this.handleFocusChange}
                                                onBlur={this.handleFocusChange}
                                                onKeyDown={(event) => { if (type === 'Instant' && event.key === "Enter") this.handleFocusChange(event) }}
                                                error={errorField === 'routingNumber'}
                                                errorMessage={type === "Instant" ? "Enter a valid 9 digit routing number that can be used for Instant (RTP/FEDNow) payments" : "Enter a valid 9 digit routing number"}
                                                disabled={aionAccount || searchInstantRoutingNumber}
                                                width='568px'
                                                suffix={searchRTPLoading && <LoadingOutlined style={{ color: theme.colors.primary, fontSize: 16, marginRight: 8 }} />}
                                                nomargin
                                            />
                                        }

                                        {
                                            (searchInstantRoutingNumber && routingNumber) &&
                                            <LabeledInput
                                                label="Routing Number"
                                                id="routingNumber"
                                                key="routingNumber"
                                                type='read-only'
                                                value={routingNumber && routingNumber}
                                                width='568px'
                                                nomargin
                                            />
                                        }

                                        {
                                            (type === 'Instant' && !searchInstantRoutingNumber && !instantInstitution) &&
                                            <TextButton
                                                icon={<Image src={Search} />}
                                                text='Find your routing number'
                                                weight='400'
                                                margin='4px 0 0'
                                                onClick={() => {
                                                    transfer.routingNumber = null
                                                    this.setState({ searchInstantRoutingNumber: true, routingNumberError: false, transfer })
                                                }}
                                            />
                                        }

                                        {
                                            (type === "Instant" && instantInstitution) &&
                                            <Flex start fullWidth centerHorizontally style={{ marginTop: 8 }} gap='8px'>
                                                {bankLogo && <Image src={bankLogo} />}
                                                <Text size='12px'>{instantInstitution?.name}</Text>
                                            </Flex>
                                        }

                                        {
                                            (type !== "Instant" && institution) &&
                                            <Flex start fullWidth centerHorizontally style={{ marginTop: 8 }} gap='8px'>
                                                {institution?.logo && <Image src={institution?.logo} />}
                                                <Text size='12px'>{institution?.name}</Text>
                                            </Flex>
                                        }
                                    </FlexColumn>
                            }

                            {
                                (type != "Check") &&
                                <FlexColumn start gap='24px'>
                                    <LabeledInput
                                        inputRef={this.accountNumberRef}
                                        label="Account Number"
                                        id="accountNumber"
                                        key="accountNumber"
                                        placeholder="Enter up to 17 digits"
                                        value={accountNumber && accountNumber}
                                        maxLength={17}
                                        onChange={this.handleTextChange}
                                        error={errorField === 'accountNumber'}
                                        errorMessage="A valid account number is required"
                                        width='568px'
                                        nomargin
                                    />

                                    {
                                        (!aionAccount) &&
                                        <LabeledInput
                                            label='Account Type'
                                            type='switch'
                                            switchNames={['Checking', 'Savings']}
                                            onChange={(value) => this.setAccountType(value)}
                                            value={accountType}
                                            error={errorField === 'accountType'}
                                            errorMessage='Account type is required'
                                            nomargin
                                        />
                                    }
                                </FlexColumn>
                            }

                            {
                                (type === 'Wire' || (type === 'Check' && checkDeliveryType == 'Postal Mail')) &&
                                <LabeledInput
                                    inputRef={this.addressOnAccountRef}
                                    label={(type === "Check") ? 'Recipient mailing address' : 'Recipient Address'}
                                    id="addressOnAccount"
                                    key="addressOnAccount"
                                    placeholder="Enter Address"
                                    tooltip="To avoid failures, verify that this is the address your recipient has registered with their bank. Tip: Request the recipient for a bank letter"
                                    address={addressOnAccount}
                                    autoFocus
                                    type="location"
                                    getLocation={(loc) => this.getLocation(loc, 'addressOnAccount')}
                                    error={errorField === 'addressOnAccount'}
                                    errorMessage="Please enter a valid recipient address"
                                    width='568px'
                                    nomargin
                                />
                            }

                            {
                                <LabeledInput
                                    label="Remittance Information"
                                    id="remittanceInfo"
                                    type="text-area"
                                    placeholder="Save any remittance info to submit along with a transfer"
                                    maxLength={rInfoLength}
                                    width='576px'
                                    optional
                                    value={remittanceInfo}
                                    autoSize={{ minRows: 1, maxRows: 2 }}
                                    onChange={this.handleTextChange}
                                    instruction={remittanceInfo ? `${remittanceInfo.length}/${rInfoLength}` : `0/${rInfoLength}`}
                                    nomargin
                                />
                            }

                            {
                                !transferMethod && <LabeledInput
                                    key="name"
                                    inputRef={this.nameRef}
                                    label='Nickname'
                                    id="name"
                                    // type={(addTransfer && transferMethod) && 'read-only'}
                                    placeholder="Enter nickname for this transfer method"
                                    value={name && name}
                                    // autoFocus
                                    nomargin
                                    maxLength={50}
                                    onChange={this.handleTextChange}
                                    error={errorField === 'name'}
                                    errorMessage={nameErrorText}
                                    width={transferMethod ? '270px' : '568px'}
                                />
                            }

                            {
                                checkDeliveryType == "Email" &&
                                <Text defaultLightText>Check will be emailed to <b>{recipientEmail}</b></Text>
                            }

                            {
                                (type === "Instant") &&
                                <div style={{ width: '550px' }}>
                                    <Banner
                                        message="Instant transfers generally complete in less than a minute. These transfers are irrevocable so please be sure to double check your recipient account number and routing number before submitting your transfer"
                                    />
                                </div>
                            }
                        </>
                    }

                    {
                        (type && type === 'International') &&

                        <FlexColumn start gap='24px' style={{ marginTop: 0 }}>
                            {
                                (() => {
                                    switch (step) {
                                        case 'currency':
                                            return <>

                                                <LabeledInput
                                                    id="country"
                                                    label="Country the recipient has a bank account in"
                                                    type="select"
                                                    // style={{ color: 'black', fontSize: "14px", paddingLeft: 0, marginLeft: 0, width: "100%" }}
                                                    bordered={false}
                                                    // className="no-left-padding"
                                                    placeholder={<span style={{ color: this.props.theme.input.placeholderTxtColor, fontWeight: 500 }}>Country</span>}
                                                    optionFilterProp="children"
                                                    onChange={value => {
                                                        transfer.name = generateUniqueNickname(transferMethodRequests, transfer?.bankName, type, value, currency, priority)
                                                        this.handleSelectCountry(value)
                                                    }}
                                                    value={country && country}
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().startsWith(input.toLowerCase())
                                                    }
                                                    autocomplete='off'
                                                    data-lpignore="true"
                                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                    error={errorField === 'country'}
                                                    errorMessage='Country is required'
                                                    className='parent-node-select-dropdown-menu'
                                                    nomargin
                                                >
                                                    {countryItems}
                                                </LabeledInput>

                                                {
                                                    country &&
                                                    <LabeledInput
                                                        label="Currency"
                                                        type='switch'
                                                        placeholder="Select a currency"
                                                        onChange={value => {
                                                            const localSupported = (currencyMap[country]?.find(item => item?.currency === value))?.localSupported;
                                                            transfer.name = generateUniqueNickname(transferMethodRequests, transfer?.bankName, type, country, value, value === "USD" ? null : !localSupported ? "SWIFT" : priority)
                                                            this.setState({
                                                                currency: value,
                                                                priority: value === "USD" ? null : !localSupported && "SWIFT",
                                                            })
                                                        }}
                                                        value={currency}
                                                        error={errorField === "currency"}
                                                        errorMessage="Please select a currency"
                                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                        className='parent-node-select-dropdown-menu'
                                                        nomargin
                                                        switchNames={Object.values(currencyMap[country]).flat().map(item => item.currency)}
                                                    />
                                                }

                                                {
                                                    (currency && currency?.toLowerCase() !== "usd") &&
                                                    <LabeledInput
                                                        label='Recipient bank details'
                                                        type='switch'
                                                        switchNames={(currencyMap[country]?.find(item => item?.currency === currency))?.localSupported ? ["Local Bank Account", "SWIFT"] : ["SWIFT"]}
                                                        onChange={(value) => {
                                                            transfer.name = generateUniqueNickname(transferMethodRequests, transfer?.bankName, type, country, currency, value)
                                                            this.setState({ priority: value, transfer })
                                                        }}
                                                        value={priority}
                                                        error={errorField == "priority"}
                                                        errorMessage='Recipient bank details are required'
                                                        nomargin
                                                    />
                                                }

                                                {
                                                    !transferMethod && <LabeledInput
                                                        key="name"
                                                        inputRef={this.nameRef}
                                                        label='Nickname'
                                                        id="name"
                                                        // type={(addTransfer && transferMethod) && 'read-only'}
                                                        placeholder="Enter nickname for this transfer method"
                                                        value={name && name}
                                                        // autoFocus
                                                        nomargin
                                                        maxLength={50}
                                                        onChange={this.handleTextChange}
                                                        error={errorField === 'name'}
                                                        errorMessage={nameErrorText}
                                                        width={transferMethod ? '270px' : '568px'}
                                                    />
                                                }
                                            </>
                                        case 'transfer':
                                            return <>
                                                {
                                                    internationalQuoteRequirements?.bicSwift &&
                                                    <LabeledInput
                                                        inputRef={this.accountNumberRef}
                                                        label="SWIFT Code"
                                                        id="bicSwift"
                                                        key="bicSwift"
                                                        placeholder={generatePlaceholderFromRegex(internationalQuoteRequirements?.bicSwift)}
                                                        value={bicSwift && bicSwift}
                                                        onChange={this.handleTextChange}
                                                        nomargin
                                                        error={errorField === "bicSwift"}
                                                        errorMessage={`A valid SWIFT Code is required. ${generatePlaceholderFromRegex(internationalQuoteRequirements?.bicSwift)}.`}
                                                        width='568px'
                                                    />
                                                }

                                                {
                                                    internationalQuoteRequirements?.iban &&
                                                    <LabeledInput
                                                        inputRef={this.accountNumberRef}
                                                        label="IBAN"
                                                        id="iban"
                                                        key="iban"
                                                        placeholder={generatePlaceholderFromRegex(internationalQuoteRequirements?.iban)}
                                                        value={iban && iban}
                                                        onChange={this.handleTextChange}
                                                        nomargin
                                                        error={errorField === "iban"}
                                                        errorMessage={`A valid IBAN is required. ${generatePlaceholderFromRegex(internationalQuoteRequirements?.iban)}.`}
                                                        width='568px'
                                                    />
                                                }

                                                {
                                                    internationalQuoteRequirements?.routingCodeType1 &&
                                                    <LabeledInput
                                                        inputRef={this.routingNumberRef}
                                                        label={internationalQuoteRequirements?.routingCodeType1?.replace(/([a-z])([A-Z])/g, '$1 $2')}
                                                        id="routingCodeValue1"
                                                        key="routingCodeValue1"
                                                        placeholder={generatePlaceholderFromRegex(internationalQuoteRequirements?.routingCodeValue1)}
                                                        value={routingCodeValue1 && routingCodeValue1}
                                                        onChange={this.handleTextChange}
                                                        error={errorField === "routingCodeValue1"}
                                                        errorMessage={`A valid ${internationalQuoteRequirements?.routingCodeType1?.replace(/([a-z])([A-Z])/g, '$1 $2')} is required. ${generatePlaceholderFromRegex(internationalQuoteRequirements?.routingCodeValue1)}.`}
                                                        disabled={aionAccount || searchInstantRoutingNumber}
                                                        width='568px'
                                                        nomargin
                                                    />
                                                }

                                                {
                                                    internationalQuoteRequirements?.routingCodeType2 &&
                                                    <LabeledInput
                                                        inputRef={this.routingNumberRef}
                                                        label={internationalQuoteRequirements?.routingCodeType2?.replace(/([a-z])([A-Z])/g, '$1 $2')}
                                                        id="routingCodeValue2"
                                                        key="routingCodeValue2"
                                                        placeholder={generatePlaceholderFromRegex(internationalQuoteRequirements?.routingCodeValue2)}
                                                        value={routingCodeValue2 && routingCodeValue2}
                                                        onChange={this.handleTextChange}
                                                        error={errorField === "routingCodeValue2"}
                                                        errorMessage={`A valid ${internationalQuoteRequirements?.routingCodeType2?.replace(/([a-z])([A-Z])/g, '$1 $2')} is required. ${generatePlaceholderFromRegex(internationalQuoteRequirements?.routingCodeType2)}.`}
                                                        width='568px'
                                                        nomargin
                                                    />
                                                }

                                                {
                                                    internationalQuoteRequirements?.receiverAccountNumber &&
                                                    <LabeledInput
                                                        inputRef={this.accountNumberRef}
                                                        label="Account Number"
                                                        id="receiverAccountNumber"
                                                        key="receiverAccountNumber"
                                                        placeholder={generatePlaceholderFromRegex(internationalQuoteRequirements?.receiverAccountNumber)}
                                                        value={receiverAccountNumber && receiverAccountNumber}
                                                        onChange={this.handleTextChange}
                                                        error={errorField === "receiverAccountNumber"}
                                                        errorMessage={`A valid account number is required. ${generatePlaceholderFromRegex(internationalQuoteRequirements?.receiverAccountNumber)}.`}
                                                        width='568px'
                                                        nomargin
                                                    />
                                                }

                                                <div style={{ height: 1, width: '100%', background: '#F2F2F2', margin: '0' }} />

                                                <Text caption spaced weight='500'>{'additional recipient details'.toUpperCase()}</Text>

                                                {
                                                    internationalQuoteRequirements?.bankName &&
                                                    <LabeledInput
                                                        inputRef={this.routingNumberRef}
                                                        label="Bank Name"
                                                        id="bankName"
                                                        key="bankName"
                                                        placeholder="Enter Bank Name"
                                                        value={bankName && bankName}
                                                        onChange={this.handleTextChange}
                                                        error={errorField === "bankName"}
                                                        errorMessage={`Bank Name is required`}
                                                        width='568px'
                                                        nomargin
                                                    />
                                                }

                                                <LabeledInput
                                                    inputRef={this.addressOnAccountRef}
                                                    label={'Recipient Address'}
                                                    id="addressOnAccountInt"
                                                    key="addressOnAccountInt"
                                                    placeholder="Enter Address"
                                                    // tooltip="To avoid failures, verify that this is the address your recipient has registered with their bank. Tip: Request the recipient for a bank letter"
                                                    address={addressOnAccountInt}
                                                    autoFocus
                                                    type="int-quote-location"
                                                    getLocation={(loc) => this.getLocation(loc, 'addressOnAccountInt')}
                                                    internationalQuoteRequirements={internationalQuoteRequirements}
                                                    error={errorField === 'addressOnAccountInt'}
                                                    errorMessage={errorMessage}
                                                    width='568px'
                                                    nomargin
                                                />
                                            </>
                                        default:
                                            return <></>
                                    }
                                })()
                            }

                        </FlexColumn>
                    }
                </FlexColumn>

                <Flex style={{ marginTop: 40 }} end fullWidth gap='24px' centerHorizontally>
                    {(type === "International" && step === 'transfer') && <TextButton text='Back' onClick={() => this.setState({ step: "currency" })} />}
                    <Button primary solid loading={loading || nextLoading} onClick={this.next} text={this.getButtonText()} />
                </Flex>
            </FlexColumn>
        )
    }
}


function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(AddTransferModal)))